import { render, staticRenderFns } from "./CompanyStore.vue?vue&type=template&id=36236420"
import script from "./CompanyStore.vue?vue&type=script&lang=js"
export * from "./CompanyStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports